import {
  FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_REQUEST,
  FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_SUCCESS,
  FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_FALUIRE,
} from './loadAllTemplateForDeletionOldTemplateTypes'

const initialState = {
  loading: false,
  allMasterTemplateForReplicationList: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_SUCCESS : return {
      ...state,
      allMasterTemplateForReplicationList: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_LOAD_ALL_MASTER_FOR_DELETE_REPLICATION_TEMPLATE_FALUIRE : return {
      ...state,
      loading: false,
      allMasterTemplateForReplicationList: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
